<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M39 17.875h-6.249v-1.25a.625.625 0 0 0-1.25 0v1.25H25.25a1.25 1.25 0 0 0-1.25 1.25V28.5a1.25 1.25 0 0 0 1.25 1.25h3.078l-1.688 2.11a.625.625 0 0 0 .484 1.016.609.609 0 0 0 .484-.234l2.313-2.891h4.407l2.313 2.891a.609.609 0 0 0 .484.234.625.625 0 0 0 .484-1.016l-1.688-2.11H39a1.25 1.25 0 0 0 1.25-1.25v-9.375a1.25 1.25 0 0 0-1.25-1.25zM30.251 26A.625.625 0 0 1 29 26v-1.874a.625.625 0 0 1 1.25 0zm2.5 0a.625.625 0 0 1-1.25 0v-3.124a.625.625 0 0 1 1.25 0zm2.5 0A.625.625 0 0 1 34 26v-4.374a.625.625 0 0 1 1.25 0z" style="fill:#517dfb" transform="translate(-22.125 -14.75)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-tutorial04',
});
</script>
